import React, {useEffect, useState} from "react";
import {IRouteParams} from "../../../contracts/router";
import {useParams} from "react-router-dom";
import {ISectionPageComponent} from "../../../contracts/pages";
import PanelMainInner from "../../PanelMainInner";
import PurchasesList from "./PurchasesList";
import ViewDetailsPurchase from "./ViewDetailsPurchase";

const PurchasesSections:React.FC = () => {
    const params:IRouteParams = useParams();
    const [type, setType] = useState<string>("list")

    const sectionPageComponent:ISectionPageComponent = {
        "undefined": <PurchasesList />,
        "list": <PurchasesList />,
        "view": <ViewDetailsPurchase />,
    }

    useEffect(() => {
        setType(params.type!)
    }, [params.type])

    return(
        <PanelMainInner title={"خرید های کاربران"} isBtn={false} isBg={true}>
            {sectionPageComponent[type]}
        </PanelMainInner>
    )
}

export default PurchasesSections